import { useImageCardForm } from "@/components/shared/forms/image-card-form";
import type { ImageCard } from "@stackje/common/config";

interface EditImageCardProps {
  card: ImageCard;
  cardIndex: number;
}

export function EditImageCard({ card }: EditImageCardProps) {
  const { formContent, previewContent, toggleType: toggleImageType, shuffleColors, handleSubmit } = useImageCardForm({
    initialData: {
      title: card.title || "",
      description: card.description || "",
      images: card.images.map((imageItem) => ({
        image: imageItem.image,
        caption: imageItem.caption || "",
      })),
      type: card.type,
      colors: card.colors,
    },
    mode: "edit",
  });

  return {
    formContent,
    previewContent,
    toggleImageType,
    shuffleColors,
    handleSubmit,
  };
}